import { Fragment } from "react";
import { useMe } from "@crehana/auth";
import { PageLoader } from "@crehana/compass.ui/v2";
import { LANGUAGES } from "@crehana/ts-types";
import { Container, PrimaryButton } from "@crehana/ui";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var LOCALES = {
  es: {
    ERROR_MESSAGE: 'Ocurrió un error al obtener tu información',
    TRY_AGAIN: 'Volver a intentarlo',
    LOGGED_OUT_MESSAGE: 'Tu sesión expiró',
    LOG_IN_AGAIN: 'Volver a conectarme'
  },
  pt: {
    ERROR_MESSAGE: 'Ocorreu um erro ao obter suas informações',
    TRY_AGAIN: 'Tente novamente',
    LOGGED_OUT_MESSAGE: 'Sua sessão expirou',
    LOG_IN_AGAIN: 'Reconectar'
  },
  en: {
    ERROR_MESSAGE: 'Oops! An error has occurred',
    TRY_AGAIN: 'Try again',
    LOGGED_OUT_MESSAGE: 'Your session has expired',
    LOG_IN_AGAIN: 'Log-in again'
  }
};
var Loading = function Loading(_ref) {
  var isDark = _ref.isDark,
    dataTestId = _ref.dataTestId,
    languageCode = _ref.languageCode;
  return /*#__PURE__*/_jsx("div", {
    className: "w-full h-screen flex flex-col items-center justify-center ".concat(isDark ? 'bg-base-dark text-white' : 'bg-white text-base-main'),
    "data-testid": dataTestId,
    children: /*#__PURE__*/_jsx(PageLoader, {
      size: "s",
      className: "mb-24",
      languageCode: languageCode
    })
  });
};
var PrivatePage = function PrivatePage(_ref2) {
  var isDark = _ref2.isDark,
    children = _ref2.children,
    _ref2$languageCode = _ref2.languageCode,
    languageCode = _ref2$languageCode === void 0 ? LANGUAGES.ES : _ref2$languageCode,
    loadingProp = _ref2.loading,
    titleProp = _ref2.title,
    labelButtonProp = _ref2.labelButton,
    organizationSlug = _ref2.organizationSlug;
  var _useMe = useMe(),
    loading = _useMe.loading,
    error = _useMe.error,
    me = _useMe.me,
    refetch = _useMe.refetch;
  var STRINGS = LOCALES[languageCode];
  var onRefetch = function onRefetch() {
    refetch();
  };
  var onLogIn = function onLogIn() {
    var next = "".concat(window.location.pathname).concat(window.location.search);
    if (organizationSlug) {
      var b2bLoginUrl = "/org/".concat(organizationSlug, "/entrar/?next=").concat(next);
      window.location.href = b2bLoginUrl;
    } else {
      window.location.href = "/entrar/?next=".concat(next);
    }
  };
  var labelButton = labelButtonProp || STRINGS.LOG_IN_AGAIN;
  var title = titleProp || STRINGS.LOGGED_OUT_MESSAGE;
  if (loading || loadingProp) {
    return /*#__PURE__*/_jsx(Loading, {
      isDark: isDark,
      languageCode: languageCode,
      dataTestId: "private-page-loading"
    });
  }
  if (error) {
    return /*#__PURE__*/_jsx("div", {
      className: "w-full h-screen flex flex-col items-center justify-center ".concat(isDark ? 'bg-base-dark text-white' : 'bg-white text-base-main'),
      children: /*#__PURE__*/_jsxs(Container, {
        className: "h-screen flex flex-col items-center justify-center text-center",
        children: [/*#__PURE__*/_jsx("h3", {
          className: "font-h3 mb-24",
          children: error ? STRINGS.ERROR_MESSAGE : title
        }), /*#__PURE__*/_jsx(PrimaryButton, {
          label: error ? STRINGS.TRY_AGAIN : labelButton,
          onClick: error ? onRefetch : onLogIn,
          darkMode: isDark
        })]
      })
    });
  }
  if (!me) {
    onLogIn();
    return /*#__PURE__*/_jsx(Loading, {
      isDark: isDark,
      languageCode: languageCode,
      dataTestId: "private-page-redirect-loading"
    });
  }
  return /*#__PURE__*/_jsx(Fragment, {
    children: children
  });
};
export default PrivatePage;